import {
  Box,
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  Theme,
} from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { useImpressionTracking } from "@outschool/ui-legacy-component-library";
import { useNodeRef } from "@outschool/ui-utils";
import React from "react";

export default function ShowMoreModal({
  buttonLabel,
  onOpen,
  trackingName,
  children,
}: {
  buttonLabel: string;
  onOpen?: () => void;
  trackingName?: string;
  children: React.ReactNode;
}) {
  const { t } = useTranslation(
    "client\\components\\detailPage\\subcomponents\\ShowMoreModal",
  );
  const [trackingNode, trackingRef] = useNodeRef();
  const { trackTouch: trackShowMoreTouch } = useImpressionTracking({
    node: trackingNode,
    uniqueId: `show_more_${trackingName}`,
    trackingLabel: `show_more_${trackingName}`,
  });

  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Button
        ref={trackingRef}
        onClick={() => {
          onOpen?.();
          trackShowMoreTouch();
          setOpen(true);
        }}
        color="neutral"
        sx={(theme: Theme) => ({
          color: "black",
          marginTop: 16,
          width: "fit-content",
          [theme.breakpoints.down("md")]: {
            width: "100%",
          },
        })}
      >
        {buttonLabel}
      </Button>
      <Modal open={open} onClose={() => setOpen(false)}>
        <ModalContent
          sx={(theme: Theme) => ({
            position: "relative",
            maxWidth: 640,
            overflow: "hidden",
            [theme.breakpoints.down("md")]: {
              maxHeight: "unset",
              margin: "unset",
              borderRadius: 1,
            },
            display: "flex",
            flexDirection: "column",
            gap: 16,
          })}
        >
          <ModalCloseButton
            aria-label={t("Close")}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              height: 48,
              width: 48,
            }}
            size={"large"}
            onClick={() => setOpen(false)}
          />
          <Box
            sx={{
              maxHeight: 860,
              flexGrow: 1,
              marginTop: 4,
              paddingRight: 24,
              marginRight: -24,
              overflowY: "auto",
              "@media (max-height: 860)": {
                maxHeight: "calc(100vh - 64px)",
              },
            }}
          >
            {children}
          </Box>
        </ModalContent>
      </Modal>
    </>
  );
}
